import { Component, OnInit } from '@angular/core';
import { VcrBaseComponent } from '../vcr-report-base.component';
import { InspectionService } from '../inspection.service';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { MediaObserver } from '@angular/flex-layout';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'quorum-vcr-report',
  templateUrl: './vcr-report.component.html',
  styleUrls: ['./vcr-report.component.scss']
})
export class VcrReportComponent implements OnInit {
  constructor(
    public inspectionService: InspectionService,
    public activatedRoute: ActivatedRoute,
    public authenticationStateService: AuthenticationStateService,
    public mediaService: MediaObserver,
    public breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit() {
    console.log(this.inspectionService.inspection);
  }
}
